import CelebrationIcon from "@mui/icons-material/Celebration";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  nextViewConnectBusinessState,
  previousViewConnectBusinessState,
} from "../redux/features/connectBusinessStateSlice";
import { connectBusinessFlowColors, connectBusinessFlowSx } from "./connectBusinessFlowStyles";

export const ConnectBusinessExpandYesEmployees = () => {
  const dispatch = useDispatch();
  const connectBusinessState = useSelector((state) => state.connectBusinessState);
  const { bestChoices = [], city, state: regionState } = connectBusinessState;

  const handleNextClick = () => {
    dispatch(nextViewConnectBusinessState());
  };

  const handleRefineClick = () => {
    // Opcional: volver para ajustar filtros/entrada previa
    dispatch(previousViewConnectBusinessState());
  };

  const plural = bestChoices.length === 1 ? "cleaner" : "cleaners";
  const locationText =
    city && regionState ? ` near ${city}, ${regionState}` : " in your area";

  return (
    <Box
      sx={{
        ...connectBusinessFlowSx.shell,
      }}
    >
      <Grid container sx={{ maxWidth: 600, mx: "auto" }}>
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              ...connectBusinessFlowSx.panel,
              textAlign: "center",
            }}
          >
            {/* Header */}
            <Avatar
              sx={{
                width: 64,
                height: 64,
                ...connectBusinessFlowSx.iconWrap,
              }}
            >
              <CelebrationIcon sx={{ fontSize: 28 }} />
            </Avatar>

            <Typography variant="h5" sx={connectBusinessFlowSx.title} gutterBottom>
              Great news
            </Typography>

            <Typography variant="body1" sx={connectBusinessFlowSx.copy}>
              We found{" "}
              <Box component="span" sx={{ color: connectBusinessFlowColors.accent, fontWeight: 800 }}>
                {bestChoices.length}
              </Box>{" "}
              {plural}
              {locationText}
            </Typography>



            <Divider sx={{ my: 3 }} />

            {/* Qué sigue / pasos */}
            <Box
              sx={{
                ...connectBusinessFlowSx.contentBand,
                textAlign: "left",
              }}
            >
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                What happens next
              </Typography>

              <Stack direction="column" spacing={1.2}>
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <TuneIcon sx={{ color: connectBusinessFlowColors.accent, mt: "2px" }} />
                  <Typography variant="body2" sx={connectBusinessFlowSx.copy}>
                    Adjust preferences if needed (services and requirements).
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <CheckCircleOutlineIcon sx={{ color: connectBusinessFlowColors.accent, mt: "2px" }} />
                  <Typography variant="body2" sx={connectBusinessFlowSx.copy}>
                    Review your best matches and see details like location and distance.
                  </Typography>
                </Stack>

              </Stack>
            </Box>

            {/* CTA principal y secundaria */}
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1.5}
              justifyContent="center"
              sx={{ mt: 3 }}
            >
              <Button
                onClick={handleNextClick}
                variant="contained"
                sx={{
                  ...connectBusinessFlowSx.primaryButton,
                }}
              >
                Next
              </Button>
            </Stack>

            {/* Nota inferior estilo Address */}
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 2 }}
            >
              You can review and adjust selections on the next screen.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
